import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { AiPreferences } from "../../api/commands/ai";
import { DigestPreferences } from "../../api/commands/digest";
import { UsageExport } from "../../api/schemas/usage";
import { Dialog } from "../../widgets/dialog";

export const Feedback = S.Struct({
	kind: S.Literals(["success", "error"]),
	message: S.String,
});

export const Model = S.Struct({
	page: S.Literal("Settings"),
	/** Weekly digest email opt-in; Refreshing while a toggle is in flight. */
	digest: apiData(DigestPreferences).schema,
	/** Whether this circle lets AI process its data; Refreshing while a toggle is in flight. */
	ai: apiData(AiPreferences).schema,
	/** Loading while exporting; Success/Failure drive `feedback`, which persists until the next attempt. */
	usageExport: apiData(UsageExport).schema,
	/** Same lifecycle as `usageExport`, for the Markdown file. */
	markdownExport: apiData(S.String).schema,
	feedback: S.Option(Feedback),
	dialog: Dialog.Model,
	deleting: S.Boolean,
	/** What the user typed; Delete stays disabled until it is DELETE. */
	deleteConfirmation: S.String,
	/** Persistent banner above the Delete button, independent of the dialog. */
	deleteError: S.Option(S.String),
});
export type Model = typeof Model.Type;
